import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useEffect, useState } from 'react';
import PatientTypeApiService from '../services/patientType.api.service';
import useAlert from './Alert/useAlert';

export const PatientTypeSelect = ({label, onChange}) => {
    const {showErrorAlert} = useAlert();
    const [patientTypes, setPatientTypes] = useState([]);

    useEffect(() => {
        PatientTypeApiService
            .list()
            .then(result => setPatientTypes(result.items))
            .catch(err => showErrorAlert(err.response.data.message));
    }, []);

    return (
        <Autocomplete
            sx={{mb: 1, mt: 1}}
            options={patientTypes}
            fullWidth
            size="small"
            onChange={(event, patientType) => onChange(patientType?.id || null)}
            getOptionLabel={patientType => patientType?.name}
            renderInput={params => <TextField {...params} variant="standard" label={label} required/>}
        />
    );
};
